<template>
  <v-dialog
      v-model="$_dialog"
      scrollable
      persistent
      transition="dialog-bottom-transition"
      max-width="800px"
  >
    <v-card outlined>
      <v-card-title class="justify-sm-center justify-start headline font-weight-black ">
        <div class="text-decoration-underline"> מדיניות פרטיות תוכנית </div>
        <div class="text-decoration-underline pr-2"> "נתיב לעסקים"   </div>
      </v-card-title>
      <v-card-text class="font-privacy-policy" style="height: 300px;">
        <p>
          חברת נתיבי איילון בע"מ ("<b>נתיבי איילון</b>") ומשרד התחבורה מובילים את תכנית נתיב לעסקים, תכנית לאומית שמטרתה ליצור שינוי בהרגלי הנסיעה של עובדים למקום עבודתם ולהפחית את השימוש ברכב הפרטי. זאת באמצעות ניתוח הצרכים של המעסיקים והעובדים בהתבסס על מידע אנונימי ואגרגטיבי (מבחינת נתיבי איילון) לצורך הצעת פתרונות תחבורתיים מותאמים אישית להגעה לעבודה חלף נסיעה ברכב הפרטי, אשר ייושמו על ידי המעסיקים והעובדים, כגון: הליכה רגלית, שימוש בתחבורה ציבורית, רכיבה על אופניים / קורקינט ועוד. ("<b>התוכנית</b>").
        </p>
        <p>
          במסגרת התוכנית ולצורך הגשמתה, נתיבי איילון עורכת בימים אלה פיילוט לבחינת יעילות וישימות התוכנית ("<b>הפיילוט</b>"). כחלק מהפיילוט, ולמען בחינתו ויישומו, העובדים מתבקשים למלא שאלון אודות הרגלי ההגעה והחזרה שלהם ממקום העבודה ("<b>השאלון</b>"). <b>במסגרת מילוי השאלון, העובד לא יידרש למלא כל מידע שבאמצעותו נתיבי איילון תוכל לזהות אותו, וכמפורט להלן ולעיל המידע שיתקבל אצל נתיבי איילון, ייאסף ויישמר על ידה הינו אנונימי בלבד ואין ביכולתה של נתיבי איילון לבצע זיהוי של מי מהעובדים שימלאו את השאלון על סמך המידע שיתקבל אצלה כתוצאה ממילויו. </b> הנך מתבקש לקרוא מדיניות פרטיות זו בטרם תשיב על השאלון.
        </p>
        <p>
          במילוי השאלון, הנך ("<b>אתה</b>" או "<b>העובד</b>") מסכים לכך שכל הפרטים שיימסרו על ידך במסגרת השאלון ("<b>המידע</b>") יועברו לנתיבי איילון, שתערוך עיבוד, ניתוח, פילוח והשוואה של הנתונים ותעביר את מסקנותיה והמלצותיה למעסיקך וכן למעסיקים נוספים שמשתתפים בפיילוט ו/או שישתתפו בתוכנית ("<b>המעסיקים</b>") ושמעסיקך, המעסיקים ונתיבי איילון יעשו שימוש במידע בקשר עם הפיילוט, התוכנית ויישומם, הכל בהתאם למדיניות פרטיות זו.
        </p>
        <p>
          להסרת ספק מובהר כי השימושים במידע והשיתופים של המידע שייערכו על ידי נתיבי איילון כמפורט להלן, ייערכו על ידה באופן אגרגטיבי אנונימי שאינו מזהה וכי אין ביכולתה של נתיבי איילון לבצע הצלבה של נתון כלשהו הנכלל במידע לצורך זיהוי העובד. המעסיקים, והם בלבד, יוכלו לבצע זיהוי של עובדיהם ולשייך את הנתונים שיועברו להם על ידי נתיבי איילון לעובד מסוים שלהם.
        </p>
        <p>
          מדיניות הפרטיות מנוסחת בלשון זכר אך פונה לגברים ונשים כאחד. כל האמור בלשון יחיד גם ברבים משמע ולהפך.
        </p>
        <p>
          לשאלות בנוגע למדיניות הפרטיות, יש ליצור קשר <b> עם עו"ד פטקין יעל </b> בטלפון<b> 03-6931266 </b>
        </p>
        <v-card-subtitle class="pr-0 font-weight-bold font-privacy-policy text-decoration-underline">
          1.	הסכמה
        </v-card-subtitle>
        <p class="pr-4">
          הנך נותן בזאת את הסכמתך לנתיבי איילון לאיסוף, שימוש, הזנה, תיעוד והעברת המידע אשר ייאסף על ידי המעסיק כתוצאה ממילוי השאלון ויועבר לנתיבי איילון באופן אנונימי ולא מזהה לצורך יישומו במסגרת הפיילוט והתוכנית, בהתאם להוראות מדיניות פרטיות זו.
        </p>
        <v-card-subtitle class="pr-0 font-weight-bold font-privacy-policy text-decoration-underline">
          2.	איסוף המידע
        </v-card-subtitle>
        <p class="pr-4">
          להלן מידע שעשוי להיאסף באמצעות השאלון בקשר עם הפיילוט והתוכנית:
        </p>
        <v-card-text class="pr-4 py-0">
          <v-card-subtitle class="font-privacy-policy pr-0 pt-0 pb-1 text-decoration-underline">2.1.	נתוני צריכה</v-card-subtitle>
          <p class="pr-4">
          מידע לא מזהה אודות הרגלי ההגעה למקום העבודה וחזרה (הגעה באמצעות רכב פרטי, תחבורה ציבורית וכו') לרבות שעות היציאה מהבית אל העבודה ומהעבודה אל הבית, מידע אודות הקשיים בעת ההגעה והחזרה מהעבודה כגון: פקקי תנועה, מחסור בחניה וכיו"ב.
          </p>
        </v-card-text>
        <v-card-text class="pr-4 py-0">
          <v-card-subtitle class="font-privacy-policy pr-0 pt-0 pb-1 text-decoration-underline">2.2.	מידע נוסף</v-card-subtitle>
          <p class="pr-4">
            בעת מילוי השאלון, העובד יתבקש לספק פרטים נוספים, כגון: פתרונות תחבורתיים בהם ישקול להשתמש כחלופה לדרכי ההגעה הנוכחיות למקום עבודתו, מרחק שנראה סביר בעיניו לתחנת איסוף (להסעות או נסיעות משותפות למקום העבודה) פרטים אודות הרגלי הנסיעה שלו למקום העבודה, כתובתו, האזור שבו נמצא מקום העבודה, האם יש בחזקתו רישיון נהיגה וכן מספר שאין ביכולתה של נתיבי איילון לשייך לעובד באופן חד חד ערכי.
          </p>
        </v-card-text>
        <v-card-text class="pr-4 py-0">
          <v-card-subtitle class="font-privacy-policy pr-0 pt-0 pb-1 text-decoration-underline">  2.3.	מידע אגרגטיבי ואנליטי</v-card-subtitle>
          <p class="pr-4">
            נתיבי איילון תאסוף, במסגרת השאלון גם נתונים דמוגרפיים כגון: גיל, מגדר, דת, מצב אישי (יש/אין ילדים) דפוסי ההתנהגות (הסעת הילדים למסגרות) ונתונים סטטיסטיים נוספים, ובלבד שאינם מזהים.
          </p>
        </v-card-text>
        <v-card-subtitle class="pr-0 font-weight-bold font-privacy-policy text-decoration-underline">
          3.	שימוש במידע
        </v-card-subtitle>
        <v-card-text class="pr-4 py-0">
          <p class="pr-4 mb-0">
            3.1.	התשובות שתימסרנה במסגרת השאלון תיאספנה ותהוונה בסיס למחקר אגרגטיבי אנונימי.
          </p>
        </v-card-text>
        <v-card-text class="pr-4 py-0">
          <v-card-text class="pr-4">
            3.2.	השימושים שנתיבי איילון עשויה לעשות במידע ייערכו, בין היתר, למטרות הבאות:
              <p class="pr-4 pa-0 mb-0">(1)	תפעול ושיפור התוכנית ומציאת פתרונות תחבורתיים להגעה וחזרה ממקום העבודה באופן רציף;</p>
              <p class="pr-4 pa-0 mb-0">(2)	ניתוח, בדיקה, עיבודים סטטיסטיים ואחרים, פילוחים, מחקר והשוואות מידע;</p>
              <p class="pr-4 pa-0 mb-0">(3)	שמירת המידע לצרכים סטטיסטיים אגרגטיביים;</p>
          </v-card-text>
        </v-card-text>
        <v-card-subtitle class="pr-0 font-weight-bold font-privacy-policy text-decoration-underline">
          4.	שיתוף והעברת המידע
        </v-card-subtitle>
        <v-card-text class="pr-4 py-0">
          <p class="pr-4 mb-0">
            4.1.	במסגרת יישום הפיילוט והתוכנית בכוונת נתיבי איילון לשתף את המידע האגרגטיבי הנ"ל (שאינו מאפשר לנתיבי איילון לזהות את העובד או כל אדם אחר באופן אישי) עם המעסיקים המשתתפים בתוכנית. כאשר כאמור לעיל, כל מעסיק יוכל לשייך את המידע לעובדים שלו בלבד באופן מזהה.           </p>
        </v-card-text>
        <v-card-text class="pr-4 py-0 pt-2">
          <p class="pr-4 mb-0">
            4.2.	בנוסף, נתיבי איילון עשויה לשתף  ולהעביר את המידע למשרד התחבורה, לנציגים, סוכנים, ספקי שירות וקבלני משנה, ולכל גוף ממשלתי לרבות משרדי ממשלה וחברות ממשלתיות, ובלבד שהעובד לא ביקש שלא למסור את המידע, וכל זאת בכפוף להוראות כל דין. כמו-כן, נתיבי איילון עשויה לחשוף את המידע ונתונים סטטיסטיים אגרגטיביים שייערכו על בסיסו לצדדים שלישיים אחרים לצורך קידום התוכנית ויישומה בפועל וכן למטרות חוקיות נוספות, כגון מחקר ופיתוח נתונים.
          </p>
        </v-card-text>
        <v-card-text class="pr-4 py-0 pt-2">
          <v-card-text class="pr-4 mb-0">
            4.3.	מבלי לגרוע מכלליות האמור, נתיבי איילון תשתף את המידע עם הגורמים המפורטים בסעיפים
            <v-card-text class="pr-4 py-0">
              <p class="mb-0">‎4.1 ו-</p>
            </v-card-text>
            <v-card-text class="pr-4 py-0">
              ‎4.2 לעיל במקרים הבאים:
              <p class="pr-4 pa-0 mb-0">
                (1)	כשהשיתוף נדרש ליישום ומימוש הפיילוט ו/או התוכנית;
              </p>
              <p class="pr-4 pa-0 mb-0">
                (2)	כשהשיתוף נדרש לכל צורך אחר, בכפוף לכך שהעובד נתן את הסכמתו לכך;
              </p>
              <p class="pr-4 pa-0 mb-0">
                (3)	כשהשיתוף נדרש לצורך עמידה בדרישות כל דין ו/או רשויות שלטון, מניעת הונאה או התחזות, עבירה, התנהגות לא נאותה או נזק, או לצורך הגנה על אינטרס חשוב של נתיבי איילון;
              </p>
              <p class="pr-4 pa-0 mb-0">
                (4)	במקרה של מכירה ו/או מיזוג בו מועברת השליטה בנתיבי איילון ו/או עיקר נכסיה לצד שלישי כלשהו ובלבד שאותו צד שלישי יכנס בנעליה לכל דבר ועניין הקשור במדיניות פרטיות זו;
              </p>
              <p class="pr-4 pa-0 mb-0">
                (5)	כשהשיתוף נדרש לצורך עיבוד המידע האגרגטיבי והאנונימי על- ידי צד ג' שאין ביכולתו לבצע זיהוי של העובד בכפוף לכך שכל חברה או אדם המעבד את המידע יסכימו לבצע את העיבוד בהתאם למדיניות פרטיות זו ולכל אמצעי סודיות ואבטחה אחרים.
              </p>
            </v-card-text>
          </v-card-text>
        </v-card-text>
        <v-card-subtitle class="pr-0 font-weight-bold font-privacy-policy text-decoration-underline">
          5.	אבטחת המידע ושמירתו
        </v-card-subtitle>
        <v-card-text class="pr-4 py-0">
          <p class="pr-4 mb-0">
            5.1.	   נתיבי איילון מייחסת חשיבות עליונה לאבטחת המידע במערכותיה. לשם שמירת המידע, נתיבי איילון מפעילה מערכות, יישומים ונהלים לאבטחת המידע, המיועדים למזער את הסיכונים מפני גניבה, פגיעה, אובדן או גישה בלתי מורשית למידע.
          </p>
        </v-card-text>
        <v-card-text class="pr-4 py-0 pt-2">
          <p class="pr-4 mb-0">
            5.2.	נתיבי איילון נוקטת צעדים סבירים כפי שנהוג כדי לסייע בהגנה על המידע אך יש לקחת בחשבון ששום אמצעי ו/או שירות אינם בטוחים באופן מוחלט, במיוחד כשהפעילות היא מקוונת. אם יש לך שאלות כלשהן בנוגע לאבטחת המידע, תוכל ליצור קשר עם <b> עו"ד פטקין יעל </b>בטלפון <b>03-6931266</b>
          </p>
        </v-card-text>
        <v-card-text class="pr-4 py-0 pt-2">
          <p class="pr-4 mb-0">
            5.3.	נתיבי איילון שומרת את המידע רק לתקופה הדרושה לצורך מימוש המטרות שלשמן הוא נאסף או לצורך עמידה בכל דרישת דיווח משפטית או אתית ו/או דרישת שמירת מסמכים.          </p>
        </v-card-text>
        <v-card-subtitle class="pr-0 font-weight-bold font-privacy-policy text-decoration-underline">
          6.	הגבלת אחריות
        </v-card-subtitle>
        <v-card-text class="pr-4 py-0">
          <p class="pr-4 mb-0">
            6.1.	נתיבי איילון אינה מבטיחה ו/או נותנת מצג כלשהו בנוגע ליישום התוכנית ו/או הפיילוט ו/או תוצאותיהם ו/או בכל עניין אחר והעובד מוותר בזאת על כל תביעה או טענה לגבי המידע שנמסר על ידו במסגרת השאלון בקשר עם הפיילוט ו/או התוכנית ו/או יישומם.          </p>
        </v-card-text>
        <v-card-text class="pr-4 py-0 pt-2">
          <p class="pr-4 mb-0">
            6.2.	ככל שמתיר זאת החוק ובהיקף המרבי אותו הוא מתיר, בשום מקרה נתיבי איילון והגורמים הקשורים אליה כולל שותפים, נושאי משרה, דירקטורים, עובדים, בעלי מניות, סוכנים, נותני רישיון, קבלני משנה וספקים לא תישא באחריות כלפי העובד ו/או כלפי כל ישות אחרת תחת כל תיאוריה משפטית, בין אם בעילה חוזית, נזיקית או אחרת, בין אם בשל נזק ישיר, עקיף, משני ו/או נסיבתי כולל ומבלי לגרוע מאבדן רווחים, אבדן הזדמנויות עסקיות, אבדן הכנסה ו/או רווח, חסרון כיס, פגיעה במוניטין, אבדן מידע, פיצויים מיוחדים, עונשיים ו/או לדוגמא; הנובעים מ ו/או קשורים בכל דרך בשאלון, בפיילוט או בתוכנית לרבות ומבלי לגרוע שימוש העובד בפתרונות התחבורה שיוצעו לו במסגרת הפיילוט ו/או התוכנית ו/או הסתמכותו עליהם ו/או על כל חלק מהם ו/או מכל תקלה, חוסר דיוק, השמטה, פגם, פרצת אבטחה ו/או כל כשל בביצוע הפיילוט ו/או התוכנית, אף אם נתיבי איילון ידעה על האפשרות שייגרמו נזקים כאמור.
          </p>
        </v-card-text>
      </v-card-text>
      <v-card-actions class="justify-center">
        <v-btn
            color="light-blue darken-2"
            dark
            @click="onAgree"
        >
          אני מסכים
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>

export default {
  name:"PrivacyPolicy",
  props:{
    dialog:{
      type: Boolean,
      require: true
    }
  },
  computed: {
    $_dialog: {
      get: function () {
        return this.dialog;
      },
      set: function (val) {
        this.$emit('closePrivacyDialog', val);
      }
    }
  },
  methods:{
    onAgree: function() {
      this.$emit('closePrivacyDialog',false)
    }
  }
};
</script>
<style scoped>
.text-decoration-underline{
  text-decoration: underline !important;
}
.font-privacy-policy{
  font-family: Arial,serif;
  color: black !important;
}
</style>